import initConfig from './init-config'
import logger from './logger'
import { pub } from './pub-sub'
import widgetConfigFromId from './widget-config'

export default function(widgetId, newSku) {
  try {
    const configFromWidgetId = widgetConfigFromId(widgetId)

    // @TODO only do this in case the sku actually changed
    // not necessary if featureFlags.observeDOM === true because the logic there will already handle no-ops

    // update sku for all active and inactive widgets
    const widgetNodes = window.document.querySelectorAll('[data-8select-widget-id]')
    const length = widgetNodes.length
    for (var i = 0; i < length; i++) {
      const node = widgetNodes[i]
      const currentWidgetId = node.getAttribute('data-8select-widget-id')
      const configFromCurrentWidgetId = widgetConfigFromId(currentWidgetId)
      if (configFromCurrentWidgetId.config.type === configFromWidgetId.config.type) {
        if (node.hasAttribute('data-identifier')) {
          node.setAttribute('data-identifier', newSku)
        } else {
          node.setAttribute('data-sku', newSku)
        }
      }
    }

    if (this.config && this.config.featureFlags && this.config.featureFlags.observeDOM === true) {
      logger('updateWidgetSku() done - exiting before widget reinit - not necessary anymore.')
      logger('featureFlag observeDOM is enabled and all widget changes are handled automatically.')

      pub('sdk:updateWidgetSku', { widgetId, newSku })

      return
    }

    // destroy all active widgets
    this.utils.widgetLoader.getAllWidgetInstances().forEach(function(widgetInstance) {
      if (widgetInstance.type === configFromWidgetId.config.type) {
        widgetInstance.destroy()
      }
    })

    this.config = initConfig()
    this.initCSE()
    pub('sdk:updateWidgetSku', { widgetId, newSku })
  } catch (error) {
    logger(`updateWidgetSku failed.`, { widgetId, newSku, error })
  }
}
